<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>{{ $t(`${getI18nPath}.title`) }}</h3>
    </template>
    <div class="content">
      <div>
        {{ $t(`${getI18nPath}.description`) }}
      </div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t("message.common.no") }}
      </ui-button>
      <ui-button color="primary" @click="$emit('toggle')">
        {{ $t("message.common.yes") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "ToggleDialog",

  props: {
    integrationType: {
      type: String,
      required: true
    },
    isEnabling: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getToggleType() {
      return this.isEnabling ? "enable" : "disable";
    },
    getI18nPath() {
      return `message.mapIntegrations.${this.integrationType}.dialog.${this.getToggleType}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  color: $grey-darker;
}
</style>
